<template>
  <Dialog
    :open="!!error"
    :dismissible="true"
    :showClose="true"
    :title="error ? error.title : ''"
    :maxWidth="380"
    @close="onClose">
    <div class="err">
      <span class="err__icon"><ion-icon name="alert-circle" /></span>
      <div class="err__body">
        <div class="err__message">{{ error ? error.message : '' }}</div>
        <!-- Only unknown errors carry a detail line (raw status · code). -->
        <div v-if="error && error.detail" class="err__detail">{{ error.detail }}</div>
      </div>
    </div>
    <button class="dlg-btn dlg-btn--ok" @click="onClose">OK</button>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog'

// App-wide error dialog for failed user-initiated security actions (bypass,
// temp-disarm, arm/disarm, approval responses). The store captures the failure
// via failAction(); this just renders it. Rendered from App.vue so it shows on
// any route.
export default {
  name: 'security-action-error-dialog',
  components: { Dialog },
  computed: {
    error: function () {
      return this.$store.getters.securityActionError
    },
  },
  methods: {
    onClose: function () {
      this.$store.dispatch('dismissSecurityActionError')
    },
  },
}
</script>

<style scoped>
.err {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.err__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 10px;
  font-size: 20px;
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.12);
}
.err__body {
  flex: 1;
  min-width: 0;
}
.err__message {
  font-size: 14px;
  line-height: 20px;
  color: var(--ion-text-color);
}
.err__detail {
  margin-top: 6px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  opacity: 0.55;
  word-break: break-word;
}
.dlg-btn {
  width: 100%;
  margin-top: 16px;
  padding: 11px 0;
  border: none;
  border-radius: 11px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.dlg-btn--ok {
  background: var(--ion-color-primary);
  color: #ffffff;
}
</style>
